"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeaturedImage;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _cdnImage = require("@insided/shared/utils/cdnImage");

var FEATURED_IMAGE_WIDTHS = [480, 700, 1000, 1400, 2000];
var FEATURED_IMAGE_SIZES = '(max-width: 1024px) 700px, 100vw';

function FeaturedImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height;
  if (!src) return (0, _preact.h)("hr", {
    className: (0, _classnames.default)('seperator', 'm-h', 'm-b-0')
  });
  var role = alt && alt.trim() !== '' ? 'img' : 'presentation';
  var srcSet = (0, _cdnImage.buildCdnSrcSet)(src, FEATURED_IMAGE_WIDTHS);
  return (0, _preact.h)("div", {
    className: "box__pad--sides--large-only"
  }, (0, _preact.h)("img", {
    className: "thread-details-featured-image qa-thread-featured-image",
    "data-qa": "thread-featured-image",
    role: role,
    src: (0, _absoluteUrlRuntime.resolveUrl)(src),
    srcSet: srcSet === '' ? undefined : srcSet,
    sizes: srcSet === '' ? undefined : FEATURED_IMAGE_SIZES,
    alt: alt,
    width: width,
    height: height,
    decoding: "async"
  }));
}